import React, { useEffect, useState } from "react";
import {wpurl} from '../gsurl'
import '../Blog.css';

const Expose = (props) => {

      const [wppost, setWPPost] = useState(null);

      useEffect(() => {


        const fetchWordPressPost = async () => {
            try {
              const response = await fetch(wpurl+'/posts?_embed&slug='+props.data.EXPOSESLUG); 
              const posts = await response.json();
              setWPPost(posts[0]);
              // setPosts(posts);
              console.log(posts[0])
            } catch (error) {
              console.error('Error fetching latest post:', error);
            }
          };
      
          fetchWordPressPost()

      }, [props]);

      if (!wppost) {
        return <div>Loading...</div>;
      }


      return (
        <div className="container">
          <div className="">
            <div className="article-content">
              <h1 className="text-4xl font-bold text-center mt-4 mb-5" dangerouslySetInnerHTML={{ __html: wppost.title.rendered }} ></h1>
              <div dangerouslySetInnerHTML={{ __html: wppost.content.rendered }} />
            </div>
          </div>
        </div>
      );


    } 

export default Expose;

